import Box from './box.svg';
import Code from './code.svg';
import Generator from './generator.svg';
import Material from './material.svg';
import Puzzle from './puzzle.svg';

export default {
  Box,
  Code,
  Generator,
  Material,
  Puzzle,
};
